(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    let scale = 1;
    const scaleStep = 0.3;
    var x = 0;


    const ATTR_INITIAL_POSITION = 'initial-image-position';

    customElements.define('product-gallery', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]'
        }

        subscriptions = {
            'variant:change': '_onVariantChange'
        }

        render() {
            this._initSwiper();
            this.subscribe('variant:change');
        }

        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, {
                
                autoHeight: true,
                pagination: {
                    el: this.$pagination,
                    type: 'bullets'
                },
                breakpoints: {
                    992: {
                        allowTouchMove: false
                    }
                },
                on: {
                    slideChange: function() {
                        scale = 1; // Reset the scale
                        updateScale(); // Apply the reset scale to the new active slide
                    }
                   
                }
            });
            
            if (this.initialPosition) {
                this.swiper.slideTo(+this.initialPosition - 1)
            }
        }

        _onVariantChange(data) {
            if(data?.variantImagePosition) {
                this.swiper.slideTo(data.variantImagePosition - 1);
            }
        }

        get slider() {
            return this.swiper;
        }

        get initialPosition() {
            return this.getAttribute(ATTR_INITIAL_POSITION)
        }
    })


    function updateScale() {
        $('.swiper-slide.swiper-slide-active img').css('transform', 'scale(' + scale + ')');
    }

    $('.mdZoomin').click(function() {
        if (scale >= 1 && scale < 5) {
            scale += scaleStep;
            updateScale();
        }
    });

    $('.mdZoomOut').click(function() {
        if (scale > 1) {
            scale -= scaleStep;
            updateScale();
        }
    });
    
})();